module.exports = __webpack_public_path__ + "static/media/task4Flower1.04261623.png";